module.exports = __webpack_public_path__ + "static/media/zksync-lite-graident.1c2e9a55.svg";